import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './i18n/config';

if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.VITE_ENV_TYPE) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV_TYPE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1,
  });
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
